import { FormInstance, Typography } from 'antd';
import { ReactNode } from 'react';

export type StepItemsArgs = { form: FormInstance };

export type StepItem = {
  title: ReactNode;
  description?: ReactNode;
};

export const stepItems: StepItem[] = [
  {
    title: 'Pagrindiniai duomenys',
    description: (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        Privalomas pildymas / pasirinkimas iš pateiktų variantų
      </Typography.Text>
    ),
  },
  {
    title: 'Ugdomosios medžiagos pritaikymas',
  },
  {
    title: 'Užduočių pritaikymas',
  },
  {
    title: 'Baziniai pritaikymai',
    description: (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        Pamokoje naudojami ugdymo būdai ir metodai
      </Typography.Text>
    ),
  },
  {
    title: 'Baziniai pritaikymai',
    description: (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        Reikalavimų personalizavimas
      </Typography.Text>
    ),
  },
  {
    title: 'Baziniai pritaikymai',
    description: (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        Teikiama individuali pagalba
      </Typography.Text>
    ),
  },
  {
    title: 'Patikrinamieji darbai',
    description: (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        Atlikimo būdai
      </Typography.Text>
    ),
  },
  {
    title: 'Patikrinamieji darbai',
    description: (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        Atlikimo sąlygos
      </Typography.Text>
    ),
  },
  {
    title: 'Vertinimas',
  },
  {
    title: 'Programos įgyvendinimo sąlygos',
    description: (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        Ugdymosi vietos ir (ar) aplinkos pritaikymas
      </Typography.Text>
    ),
  },
  {
    title: 'Programos įgyvendinimo sąlygos',
    description: (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        Specialiosios mokymo priemonės
      </Typography.Text>
    ),
  },
  {
    title: 'Pastabos, komentarai',
  },
  {
    title: 'Duomenų peržiūra',
  },
];
